import type React from "react";

import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { MAX_ATTENDEES } from "app/pages/sales-intelligence/pages/ai-agent/constants";

type Props = {
    isEnabled: boolean;
    children: React.ReactElement;
};

export const AttendeesLimitTooltip = ({ isEnabled, children }: Props) => (
    <Tooltip
        enabled={isEnabled}
        content={translate("si.pages.ai_agent.form.keyAttendees.limit_reached", { max: MAX_ATTENDEES })}
        placement="top"
    >
        {children}
    </Tooltip>
);
